import React  from "react";
import { useTranslation } from "react-i18next";
import "./profile.css";

const Describe = ({ userInfo, handleChange }) => {
  const { t } = useTranslation();
  const counterLength = 60;
  const bio = userInfo.bio;

  return (
    <div>
      {/* <div className="flex-wrapper ">
        <div className="text-count">
          {bio.length} / {counterLength}
        </div>
        <input
          type="text"
          placeholder={t("Professional Headline to describe yourself")}
          autoComplete="off"
          name="bio"
          maxLength={counterLength}
          value={bio}
          onChange={handleChange}
        />
      </div> */}
    </div>
  );
};

export default Describe;
